module.exports = "/images/icon_loud01.png?fe10be7c9ce11fe12138fcd4d1830bb2";